import React from 'react';
import { WHATSAPP_NUMBER } from '../lib/whatsapp';

const WhatsAppButton = () => {
  const url = `https://wa.me/${WHATSAPP_NUMBER}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 group"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="w-8 h-8 fill-white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.906 15.906 0 0016.004 32C24.826 32 32 24.826 32 16.004 32 7.176 24.826 0 16.004 0zm9.302 22.602c-.388 1.094-1.938 2.002-3.164 2.266-.84.178-1.936.32-5.63-1.21-4.726-1.956-7.768-6.752-8.004-7.066-.226-.314-1.898-2.53-1.898-4.826 0-2.296 1.202-3.428 1.628-3.894.388-.424.916-.602 1.22-.602.148 0 .28.008.4.014.426.018.64.044.92.714.352.838 1.21 2.95 1.316 3.164.108.216.216.498.072.79-.134.3-.252.434-.468.682-.216.248-.422.438-.638.706-.198.232-.422.48-.174.906.248.424 1.104 1.82 2.372 2.948 1.632 1.452 3.006 1.902 3.432 2.114.426.212.674.178.922-.108.248-.286 1.066-1.242 1.35-1.668.284-.426.568-.354.956-.212.39.142 2.472 1.166 2.896 1.378.426.214.708.32.812.498.104.178.104 1.032-.284 2.124z"/>
      </svg>
      <span className="absolute right-16 bg-white text-gray-800 text-sm font-medium px-3 py-1.5 rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Chat with us
      </span>
    </a>
  );
};

export default WhatsAppButton;
